import {
    DataSourceMode, Panel, Snackbar, TableRow, TableRowDisplayEvent, TableRowMode, Textbox, ValidationResult
} from "@mcleod/components";
import { AutogenLayoutTableDirectDeposit } from "./autogen/AutogenLayoutTableDirectDeposit";
import { CurrencySettings } from "@mcleod/core";

export class TableDirectDeposit extends AutogenLayoutTableDirectDeposit {

    onLoad(): void {
        if (!CurrencySettings.getSingleton().multiCurrencyEnabled()) {
            this.tableDirectDeposit.removeColumn("columnHeaderCountry");
            this.tableDirectDeposit.removeColumn("columnHeaderCurrency");
        }
    }

    tableDirectDepositOnRowDisplay(event: TableRowDisplayEvent) {
        this.setAccountNumberDisplay(event.getTableRow(), event.getTableRow().mode != TableRowMode.QUICK_ADD);
    }

    private setAccountNumberDisplay(row: TableRow, isPassword: boolean) {
        const accountNumber = row.findComponentById("textboxAccountNumber") as Textbox;

        if (accountNumber != undefined) {
            accountNumber.password = isPassword;
            accountNumber.displayData(row.data, null, 0);

            accountNumber.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                if (accountNumber.text.length > 17) {
                    return { component: accountNumber, isValid: false, validationMessage: "Please enter in a value that is 17 digits or less." };
                }
                return null;
            };
        }
    }

    public useMethodSetup(): void {
        this.tableDirectDeposit.removeColumn("columnHeaderCurrentPercent");
        this.tableDirectDeposit.removeColumn("columnHeaderNewPercent");
    }

    public usePercentSetup(): void {
        this.tableDirectDeposit.removeColumn("columnHeaderCurrentMethod")
        this.tableDirectDeposit.removeColumn("columnHeaderCurrentAmount")
        this.tableDirectDeposit.removeColumn("columnHeaderMethod")
        this.tableDirectDeposit.removeColumn("columnHeaderNewAmount")
    }

    public getDirectDepositPercentageTotal(): [boolean, Map<string, number>] {
        let percentageTotal: number = 0;
        let hasPercentageRow = false;

        const currencyPercentageTotals: Map<string, number> = new Map();

        this.tableDirectDeposit.rows.forEach(tableRow => {
            if (tableRow.data.get("acct_activated") == "Y" && !tableRow.data.isNull("new_deposit_amt")) {
                const newMethod = tableRow.data.get("new_deposit_method");
                const newAmt = tableRow.data.getNumber("new_deposit_amt", 0);
                const curMethod = tableRow.data.get("new_deposit_method");
                const curAmt = tableRow.data.getNumber("cur_deposit_amt", 0);
                const currencyType = tableRow.data.get("currency_type");

                percentageTotal = currencyPercentageTotals.get(currencyType) ?? 0;

                if (newMethod == "%" && curMethod == "%") {
                    hasPercentageRow = true;
                    if (curAmt == 0.0) {
                        percentageTotal += newAmt;
                    } else if (newAmt == 0.0) {
                        percentageTotal += curAmt;
                    } else {
                        percentageTotal += newAmt;
                    }
                } else if (newMethod == "%") {
                    hasPercentageRow = true;
                    percentageTotal += newAmt;
                } else if (curMethod == "%" && newAmt == 0.0) {
                    hasPercentageRow = true;
                    percentageTotal += curAmt;
                }
                currencyPercentageTotals.set(currencyType, percentageTotal);
            }
        });

        return [hasPercentageRow, currencyPercentageTotals];
    }

    public percentagesValid(percentageTotals: Map<string, number>): boolean {
        if (percentageTotals.size === 0) {
            return false;
        }
        for (const value of percentageTotals.values()) {
            if (value !== 100) {
                return false;
            }
        }
        return true;
    }

    public validateDirectDepositPercentageDistribution(focusComponent: Textbox, targetPanel: Panel): boolean {
        const [_hasPercentageRow, percentageTotals] = this.getDirectDepositPercentageTotal();
        if (this.percentagesValid(percentageTotals)) {
            return true;
        }

        focusComponent.focus();
        Snackbar.showWarningSnackbar("Direct deposit distribution must total 100%.", {
            millisUntilDismissal: 8000,
            targetPanel
        });
        return false;
    }

}
